import DeviceManager from '../utils/device-manager';
import $ from "jquery";
import Flickity from "flickity-fade";
import "flickity-imagesloaded";

class ServicesSlider {
    constructor($el) {
        this.$el = $el;

        this.options = {
            pageDots: false,
            wrapAround: true,
            prevNextButtons: false,
            cellSelector: '.service',
            cellAlign: 'left',
        };

        if(this.$el.length) {
            this._init();
            this._bindEvents();
        }
    }

    _init() {
        if (document.body.clientWidth < 768 ) {
            this.slider = new Flickity(this.$el[0], this.options);
            // console.log('Slider des services');
        } else {
            // console.log('No slider des services');
        } 
    }

    _bindEvents() {
        this._onBreakpointChangeFn = this._onBreakpointChange.bind(this);

        DeviceManager.on('device-manager:breakpointChange', this._onBreakpointChangeFn);
    }

    _destroy() {
        if(this.slider) {
            this.slider.destroy();
            this.slider = null;
        }
    }

    _onBreakpointChange() {
        if (document.body.clientWidth < 768 ) {
            this._destroy();
            this.slider = new Flickity(this.$el[0], this.options);
            // console.log('slider resize mobile');
        } else {
            this._destroy();
            // console.log('No slider services');
        }
    }
}

export default ServicesSlider;
